// extracted by mini-css-extract-plugin
export var logo = "nav-module--logo--1MwOM";
export var language = "nav-module--language--204t1";